/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { CmsEditingCompany } from '../model/cmsEditingCompany';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable()
export class CMSCompaniesService {
  protected basePath = '/';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   *
   * Create company
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cmsCreateCompany(
    body?: CmsEditingCompany,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<CmsEditingCompany>;
  public cmsCreateCompany(
    body?: CmsEditingCompany,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<CmsEditingCompany>>;
  public cmsCreateCompany(
    body?: CmsEditingCompany,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<CmsEditingCompany>>;
  public cmsCreateCompany(
    body?: CmsEditingCompany,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<CmsEditingCompany>(
      'post',
      `${this.basePath}/cms/companies`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   *
   * Get company
   * @param company_id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cmsGetCompany(
    company_id: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<CmsEditingCompany>;
  public cmsGetCompany(
    company_id: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<CmsEditingCompany>>;
  public cmsGetCompany(
    company_id: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<CmsEditingCompany>>;
  public cmsGetCompany(
    company_id: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (company_id === null || company_id === undefined) {
      throw new Error(
        'Required parameter company_id was null or undefined when calling cmsGetCompany.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<CmsEditingCompany>(
      'get',
      `${this.basePath}/cms/companies/${encodeURIComponent(
        String(company_id)
      )}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   *
   * Update company
   * @param company_id
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cmsUpdateCompany(
    company_id: number,
    body?: CmsEditingCompany,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<CmsEditingCompany>;
  public cmsUpdateCompany(
    company_id: number,
    body?: CmsEditingCompany,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<CmsEditingCompany>>;
  public cmsUpdateCompany(
    company_id: number,
    body?: CmsEditingCompany,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<CmsEditingCompany>>;
  public cmsUpdateCompany(
    company_id: number,
    body?: CmsEditingCompany,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (company_id === null || company_id === undefined) {
      throw new Error(
        'Required parameter company_id was null or undefined when calling cmsUpdateCompany.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<CmsEditingCompany>(
      'put',
      `${this.basePath}/cms/companies/${encodeURIComponent(
        String(company_id)
      )}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
